import {useCallback} from 'react';
import useSearchParams from './useSearchParams.js';

export default function () {
  const {searchParams, setSearchParams} = useSearchParams();

  const collectionId = searchParams.get('collection');
  const zoom = searchParams.get('zoom');

  const setCollection = useCallback(
    (id, zoomToExtent = false) => {
      searchParams.set('collection', id);
      if (zoomToExtent) {
        // silly, but lets the collection know to zoom when we arrive
        searchParams.set('zoom', 'zoom');
      }
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams]
  );

  const resetCollection = useCallback(() => {
    searchParams.delete('collection');
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  return {collectionId, setCollection, resetCollection, zoom};
}
